import { MutationTree } from "vuex";
import { RecoveryState, AuditLog } from "./state";

export const mutations: MutationTree<RecoveryState> = {
  SET_SEARCH_RESULTS(state, results: any[]) {
    state.searchResults = results;
  },
  SET_IS_SEARCHING(state, isSearching: boolean) {
    state.isSearching = isSearching;
  },
  SET_AUDIT_LOGS(state, logs: AuditLog[]) {
    state.auditLogs = logs;
  },
  ADD_AUDIT_LOG(state, log: AuditLog) {
    state.auditLogs.unshift(log);
  },
};
